/** Yaygın SIP yanıt kodları — Netgsm giden arama */
const SIP_KOD_ACIKLAMA = {
  400: 'Geçersiz istek — numara veya SIP hedefi hatalı olabilir.',
  401: 'Kimlik doğrulama hatası.',
  402: 'Ödeme gerekli — Netgsm bakiye/kontör yetersiz olabilir.',
  403: 'Yetkisiz — giden arama izni veya bakiye sorunu olabilir.',
  404: 'Hedef bulunamadı — aranan numara veya SIP URI geçersiz.',
  408: 'Zaman aşımı — santral yanıt vermedi.',
  480: 'Geçici olarak ulaşılamıyor.',
  486: 'Karşı taraf meşgul veya hat kullanımda.',
  487: 'Arama iptal edildi.',
  600: 'Tüm hatlar meşgul — Netgsm giden arama kapasitesi dolu olabilir.',
  488: 'Ses codec uyumsuzluğu.',
  503: 'Netgsm santral servisi geçici olarak kullanılamıyor.',
};

const GIDEN_BUSY_MESAJ =
  'Giden arama tamamlanamadı — hat meşgul (Busy). Karşı taraf gerçekten meşgul olabilir; '
  + 'numara doğruysa Netgsm panelinden giden arama bakiyesi, dahili yetkisi ve hat kapasitesini kontrol edin.';

const CAUSE_ACIKLAMA = {
  Rejected: 'Arama reddedildi.',
  Busy: 'Hat meşgul.',
  Unavailable: 'Ulaşılamıyor.',
  Canceled: 'Arama iptal edildi.',
  'Request Timeout': 'Santral zaman aşımına uğradı.',
  'SIP Failure Code': 'SIP hata kodu alındı.',
  'WebRTC Error': 'WebRTC ses bağlantısı kurulamadı.',
  'User Denied Media Access': 'Mikrofon izni reddedildi.',
  'Bad Media Description': 'SDP/medya tanımı hatalı.',
  'Incompatible SDP': 'Ses parametreleri uyumsuz.',
};

const bakiyeAnahtarlari = /bakiye|balance|credit|yetersiz|insufficient|limit|quota|kontor|kontör|dakika|prepaid|package|paket/i;
const yetkiAnahtarlari = /yetki|auth|forbidden|not allowed|izin|permission|unauthorized/i;

/**
 * JsSIP session failed / SIP yanıtını kullanıcı dostu Türkçe mesaja çevirir.
 * @param {object} [data] - JsSIP failed event data
 * @param {{ giden?: boolean }} [opts]
 */
export const formatNetgsmSipHata = (data, { giden = false } = {}) => {
  const response = data?.message || data?.response;
  const statusCode = Number(response?.status_code ?? response?.statusCode ?? 0) || null;
  const reason = String(response?.reason_phrase ?? response?.reasonPhrase ?? '').trim();
  const cause = String(data?.cause ?? '').trim();
  const birlesik = `${reason} ${cause}`.toLowerCase();

  if (bakiyeAnahtarlari.test(birlesik)) {
    return 'Netgsm: Kontör/bakiye yetersiz veya giden arama paketi tanımlı değil. Netgsm panelinden bakiyenizi kontrol edin.';
  }
  if (yetkiAnahtarlari.test(birlesik) || statusCode === 403) {
    return 'Netgsm: Bu dahiliden giden arama yetkisi yok veya hesap kısıtlı (403). Netgsm Netsantral ayarlarını kontrol edin.';
  }
  if (statusCode === 402) {
    return 'Netgsm: Bakiye yetersiz (402). Giden arama için kontör yükleyin.';
  }
  if (statusCode && SIP_KOD_ACIKLAMA[statusCode]) {
    if (giden && (statusCode === 486 || statusCode === 600)) {
      return GIDEN_BUSY_MESAJ;
    }
    const ek = reason && !SIP_KOD_ACIKLAMA[statusCode].includes(reason) ? ` (${reason})` : '';
    return `Netgsm SIP ${statusCode}: ${SIP_KOD_ACIKLAMA[statusCode]}${ek}`;
  }
  if (statusCode && reason) {
    return `Netgsm SIP ${statusCode}: ${reason}`;
  }
  if (reason) {
    return `Netgsm: ${reason}`;
  }
  if (cause === 'Busy' && giden) {
    return GIDEN_BUSY_MESAJ;
  }
  if (cause && CAUSE_ACIKLAMA[cause]) {
    const temel = CAUSE_ACIKLAMA[cause];
    return giden ? `Giden arama başarısız — ${temel}` : temel;
  }
  if (cause) {
    return giden ? `Giden arama başarısız: ${cause}` : `Görüşme hatası: ${cause}`;
  }
  return giden
    ? 'Giden arama başlatılamadı. Netgsm bakiye, dahili yetkisi ve numara formatını kontrol edin.'
    : 'Görüşme bağlantısı kurulamadı.';
};

/** Geliştirici konsolu için ham SIP detayı */
export const sipHataDebugOzet = (data) => {
  const response = data?.message || data?.response;
  return {
    cause: data?.cause,
    statusCode: response?.status_code ?? response?.statusCode,
    reason: response?.reason_phrase ?? response?.reasonPhrase,
  };
};
